import { Directive, HostBinding, Input, Optional, SkipSelf } from '@angular/core';

@Directive({
  selector: 'input'
})
export class AutoCompleteDirective {

  private _default!: string;
  private _autocomplete!: string;
  
  @HostBinding('attr.autocomplete')
  @Input()
  set autocomplete(value: string) {
    this._autocomplete = value;
  }
  
  get autocomplete(): string {
    return this._autocomplete || this._default;
  }

  constructor(
   
  ) {
   
  }

}
